<div class="Dialog" mat-dialog-content>
  <div>
    <p>Are you sure you want to remove all favorited items?</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true" class="ThemeColorAccent">Yes, remove all</button>
    <button mat-button cdkFocusInitial [mat-dialog-close]="false" class="ThemeColorAccent">No, keep all</button>
  </mat-dialog-actions>
</div>
